export default class CustomInputPhoneMask {
  public static format(value: string): string {
    // Remove todos os caracteres não numéricos
    let cleanedValue = value.replace(/\D/g, '');
  
    // Limita o valor a 11 caracteres numéricos
    if (cleanedValue.length > 11) {
      cleanedValue = cleanedValue.slice(0, 11);
    }
  
    // Aplica a formatação
    if (cleanedValue.length === 11) {
      cleanedValue = cleanedValue.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3'); // Formato: (XX) XXXXX-XXXX
    } else if (cleanedValue.length === 10) {
      cleanedValue = cleanedValue.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3'); // Formato: (XX) XXXX-XXXX
    }
  
    return cleanedValue; // Retorna o valor formatado
  }
}
  
